var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1832_26867)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0.5 0.10022)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1832_26867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.0994C14.7652 1.0994 15.0196 1.20475 15.2071 1.39229C15.3946 1.57983 15.5 1.83418 15.5 2.0994V14.0994C15.5 14.3646 15.3946 14.619 15.2071 14.8065C15.0196 14.994 14.7652 15.0994 14.5 15.0994H2.5C2.23478 15.0994 1.98043 14.994 1.79289 14.8065C1.60536 14.619 1.5 14.3646 1.5 14.0994V2.0994C1.5 1.83418 1.60536 1.57983 1.79289 1.39229C1.98043 1.20475 2.23478 1.0994 2.5 1.0994H14.5ZM2.5 0.0993958C1.96957 0.0993958 1.46086 0.310109 1.08579 0.685182C0.710714 1.06025 0.5 1.56896 0.5 2.0994V14.0994C0.5 14.6298 0.710714 15.1385 1.08579 15.5136C1.46086 15.8887 1.96957 16.0994 2.5 16.0994H14.5C15.0304 16.0994 15.5391 15.8887 15.9142 15.5136C16.2893 15.1385 16.5 14.6298 16.5 14.0994V2.0994C16.5 1.56896 16.2893 1.06025 15.9142 0.685182C15.5391 0.310109 15.0304 0.0993958 14.5 0.0993958H2.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.0994C8.63261 4.0994 8.75979 4.15207 8.85355 4.24584C8.94732 4.33961 9 4.46679 9 4.5994V7.5994H12C12.1326 7.5994 12.2598 7.65207 12.3536 7.74584C12.4473 7.83961 12.5 7.96679 12.5 8.0994C12.5 8.232 12.4473 8.35918 12.3536 8.45295C12.2598 8.54672 12.1326 8.5994 12 8.5994H9V11.5994C9 11.732 8.94732 11.8592 8.85355 11.9529C8.75979 12.0467 8.63261 12.0994 8.5 12.0994C8.36739 12.0994 8.24021 12.0467 8.14645 11.9529C8.05268 11.8592 8 11.732 8 11.5994V8.5994H5C4.86739 8.5994 4.74021 8.54672 4.64645 8.45295C4.55268 8.35918 4.5 8.232 4.5 8.0994C4.5 7.96679 4.55268 7.83961 4.64645 7.74584C4.74021 7.65207 4.86739 7.5994 5 7.5994H8V4.5994C8 4.46679 8.05268 4.33961 8.14645 4.24584C8.24021 4.15207 8.36739 4.0994 8.5 4.0994Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1832_26867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.10022)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1832_26867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.10022)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/iconAdd.a5dc3e3759d558a0a952321c9e2b302a.svg";
export { ForwardRef as ReactComponent };